"use client";

import MergedApp from "@/components/merged/MergedApp";

export default function Home() {
  return (
    <div className="w-full min-h-screen">
      <MergedApp />
    </div>
  );
}
